
import router from '@/router';
import { ApartmentService } from '@/services/ApartmentService';
import { apiUrl, axiosAuthPost } from '@/services/utils';
import { defineComponent } from 'vue'

export default defineComponent({
    setup() {

    },
    data() {
        return {
            spin: false,
            hasClicked: false,
            formData: {
                name: "",
                description: "",
                type: "classic",
                price: "",
                ac: false,
                balcony: false,
                beds: 0
            },
        }
    },
    methods: {
        async createApartment() {
            this.hasClicked = true;
            this.spin = true;
            let result = await new ApartmentService().createApartment(this.formData)
            this.spin = false;
            this.hasClicked = false;
            this.$emit('apartmentCreated');
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Apartment successfully created', life: 3000 });
        },
    }
})
